import CodeEditor from "./CodeEditor.jsx";

export default function QuestionRenderer({ question, selected, onSelect, onCodeSubmit }) {
  if (!question) return null;

  // Handle coding questions (only if it's a coding problem, not MCQ)
  if (question.category === "coding" && !question.optionA && !question.optionB) {
    return (
      <CodeEditor 
        problem={question} 
        onSubmit={onCodeSubmit}
      />
    );
  }

  // Handle multiple-choice questions
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">
        {question.questionText || question.question}
      </h2>

      
      {question.options ? (
        // Multiple choice format
        question.options.map((opt, i) => (
          <button
            key={i}
            onClick={() => onSelect(opt)}
            className={`w-full text-left px-4 py-3 rounded border
              ${
                selected === opt
                  ? "bg-blue-50 border-blue-600"
                  : "bg-white hover:bg-slate-100"
              }`}
          >
            <b>{String.fromCharCode(65 + i)}.</b> {opt}
          </button>
        ))
      ) : (
        // Manual options format (A, B, C, D)
        ['A', 'B', 'C', 'D'].map((option) => {
          const optionText = question[`option${option}`];
          if (!optionText) return null;
          
          return (
            <button
              key={option}
              onClick={() => onSelect(option)}
              className={`w-full text-left px-4 py-3 rounded border
                ${
                  selected === option
                    ? "bg-blue-50 border-blue-600"
                    : "bg-white hover:bg-slate-100"
                }`}
            >
              <b>{option}.</b> {optionText}
            </button>
          );
        })
      )}
    </div>
  );
}
